import { Component, Input } from '@angular/core';
import { RunTransitionWithDialog } from '../services/workflow/workflow.service';
import { PayeeIconComponent } from '../payee-icon/payee-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'payee-workflow-provided-media',
  templateUrl: './payee-workflow-provided-media.component.html',
  styleUrls: ['./payee-workflow-provided-media.component.scss'],
  imports: [PayeeIconComponent, TranslateModule],
})
export class PayeeWorkflowProvidedMediaComponent {
  @Input({ required: true }) transitionWithDialog!: RunTransitionWithDialog;
}
